module.exports = __webpack_public_path__ + "img/路径 4028.7fd35cc2.svg";